import React, {FC} from 'react';

import Stack from '@mui/material/Stack';
import Highlight from 'react-highlight';


import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import GeomaticoLink from '../../components/GeomaticoLink';
import SwitchPad from '@geomatico/geocomponents/Forms/SwitchPad';
import {COLOR_RAMPS} from '../../config';
import AnimatedSlider from '../../components/AnimatedSlider';

const ScrollableContent = styled(Box)({
  overflow: 'auto',
  padding: '8px',
});

const stackSx = {
  height: '100%',
  overflow: 'hidden'
};

export type SidePanelContentProps = {
  colorRamp: string
  onColorRampChange: (colors: string[]) => void,
  year: number,
  onYearChange: (year: number) => void,
};

const codeExample = `maplibregl.addProtocol('cog', cogProtocol);

const sources = {
  'imageSource': {
    type: 'raster',
    url: 'cog://https://cdn.geomatico.es/' +
      'MAP_SSTY_val_cog_timeseries.tif' + 
      '#color:BrewerSpectral11,13,24',
    tileSize: 256
  }
};

const layers = [{
  source: 'imageSource',
  id: 'imageLayer',
  type: 'raster'
}];

`;

const SidePanelContent: FC<SidePanelContentProps> = ({colorRamp, year, onYearChange, onColorRampChange}) =>
  <Stack sx={stackSx}>
    <ScrollableContent>
      <h1>Multiband timeseries animation</h1>
      <Highlight className="typescript">
        {codeExample}
      </Highlight>
      <SwitchPad
        selected={[colorRamp]}
        onSelectionChange={onColorRampChange}
        categories={COLOR_RAMPS}
        exclusive={true}
      />
      <AnimatedSlider value={year} min={1982} max={2020} onValueChange={onYearChange}/>
    </ScrollableContent>
    <GeomaticoLink/>
  </Stack>;

export default SidePanelContent;
